import { Component, Input } from '@angular/core';
import { CONTACT_LABELS, ContactKind, contactKinds, MessagePart, splitContact } from './contact-share.util';

/**
 * A guest/host message's text with any phone number, email, link or off-site
 * payment mention highlighted, and a tag saying what it shares.
 */
@Component({
  selector: 'admin-message-body',
  standalone: true,
  template: `
    @if (kinds.length) {
      <span class="tags">
        @for (k of kinds; track k) {
          <span class="tag">{{ labels[k] }}</span>
        }
      </span>
    }
    <!-- Each piece in its own element, so no template whitespace lands around a highlight. -->
    <span class="text">
      @for (p of parts; track $index) {
        <span [class.hit]="!!p.kind" [attr.title]="p.kind ? labels[p.kind] : null">{{ p.text }}</span>
      }
    </span>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .text {
        white-space: pre-line;
      }
      .tags {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        margin: 2px 0 4px;
      }
      .tag {
        padding: 1px 8px;
        border-radius: 9999px;
        background: rgba(var(--cnt-trinidad-rgb), 0.12);
        color: var(--cnt-trinidad);
        font-size: 0.75rem;
        font-weight: 700;
      }
      .hit {
        padding: 0 2px;
        border-radius: 3px;
        background: rgba(251, 215, 132, 0.7);
        color: inherit;
      }
    `,
  ],
})
export class AdminMessageBodyComponent {
  parts: MessagePart[] = [];
  kinds: ContactKind[] = [];
  readonly labels = CONTACT_LABELS;

  @Input() set text(value: string | null | undefined) {
    this.parts = splitContact(value);
    this.kinds = contactKinds(value);
  }
}
